"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InvitationOverview() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const handleScroll = () => {
        setScrollY(window.scrollY);
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: subheadRef,
    isVisible: subheadVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233968" id="services-hero" className="relative flex min-h-[90vh] w-full items-center justify-center overflow-hidden bg-background !h-[750px] !p-0">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.15] transition-transform duration-75 ease-linear" style={{
      transform: `translateY(${scrollY * 0.15}px)`
    }} aria-hidden="true">
        <svg viewBox="0 0 200 200" className="h-[150%] w-[150%] max-w-none fill-primary md:h-[120%] md:w-[120%]" xmlns="http://www.w3.org/2000/svg">
          {}
          <path d="M0 100 L200 100 M100 0 L100 200 M50 0 L50 200 M150 0 L150 200 M0 50 L200 50 M0 150 L200 150" stroke="currentColor" strokeWidth="0.5" fill="none" />
          <circle cx="100" cy="100" r="80" stroke="currentColor" strokeWidth="0.5" fill="none" />
          <circle cx="100" cy="100" r="40" stroke="currentColor" strokeWidth="0.5" fill="none" />
        </svg>
      </div>

      {}
      <div className="relative z-10 flex max-w-5xl flex-col items-center px-6 text-center">
        <div ref={headlineRef} className={`transition-all duration-1000 ease-out ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="font-default text-6xl font-bold uppercase tracking-tighter text-foreground md:text-[84px]">Թիրախային ծառայություններ<br /><span className="block h-1.5 w-full mt-4 bg-chart-3" data-ast-id="f:/src/pages/Services/sections/InvitationOverview.tsx|sig:2npe44" data-ast-start="2577" data-ast-end="2637"></span></h1>
        </div>

        <div ref={subheadRef} className={`mt-8 transition-all duration-1000 ease-out delay-300 ${subheadVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <p className="font-default text-sm font-medium uppercase tracking-widest text-muted-foreground md:text-base md:tracking-[0.4em]">Տիեզերական հեռազննում •Բարձր ճշգրտության գեոդեզիա • Ժամանակակից քարտեզագրում</p>
        </div>

        <div ref={ctaRef} className={`mt-16 transition-all duration-1000 ease-out delay-500 ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild variant="outline" size="lg" className="rounded-md border-chart-3 bg-chart-3 px-10 py-6 font-default text-sm font-bold uppercase tracking-wider text-primary-foreground transition-all duration-300 hover:bg-chart-3/90 hover:shadow-lg hover:shadow-chart-3/20">
            
          </Button>
        </div>
      </div>
    </section>;
}